import React from "react";
import StackHorizontal from "../Wrappers/StackHorizontal";
import {FlexGap, FlexJustify} from "../../Data/Enums/LayoutEnums";

interface BasicPageHeaderType {
    title: string;
    children?: any;
}

interface StackedAddonPageHeaderType {
    title: string;
    addon: any;
    content: any;
}

const BasicPageHeader = (props: BasicPageHeaderType) => {
    return (
        <div className={'page-header'}>
            <h4 className={'m-0'}>{props.title}</h4>
            {props.children}
        </div>
    )
}

const StackedBasicPageHeader = (props: BasicPageHeaderType) => {
    return (
        <div className={'page-header page-header-stacked'}>
            <div className={'flex-column flex-gap-sm '}>
                <h4 className={'m-0'}>{props.title}</h4>
                {props.children}
            </div>
        </div>
    )
}

const StackedAddonPageHeader = (props: StackedAddonPageHeaderType) => {
    return (
        <div className={'page-header page-header-stacked'}>
            <StackHorizontal gap={FlexGap.Small} justify={FlexJustify.Between}>
                <h4 className={'m-0'}>{props.title}</h4>
                {props.addon}
            </StackHorizontal>
            {props.content}
        </div>
    )
}

export {StackedBasicPageHeader, StackedAddonPageHeader }

export default BasicPageHeader